import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MessageService } from 'src/app/services/message.service';

/**
 * Where the backend sends the browser after a directory sign-in, with a one-time code. The code is
 * exchanged for the session, then the user resumes where they were going. The destination comes from
 * the backend answer, never from the URL.
 */
@Component({
  selector: 'app-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrls: ['./sso-callback.component.scss']
})
export class SsoCallbackComponent implements OnInit {

  constructor(
    private _message: MessageService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  async ngOnInit() {
    const code = this.route.snapshot.queryParamMap.get('code');
    if (!code) {
      this.toLogin('SSO_CODE_INVALID');
      return;
    }
    try {
      this._message.emitChange("LOADING", "START");
      const session = await firstValueFrom(this.authService.exchange(code));
      if (session.user.lang) {
        this.translate.use(session.user.lang);
      }
      this._message.emitChange("LOADING", "END");
      // replaceUrl: the one-time code does not stay in the browser history.
      await this.router.navigateByUrl(session.returnTo || '/', { replaceUrl: true });
      // A full page load brought the browser here: the translations may still be loading.
      const texts = await firstValueFrom(this.translate.get(["LOGIN.GOOD_TO_SEE_YOU_BACK", "LOGIN.TITLE"], session.user));
      this.toastr.info(texts["LOGIN.GOOD_TO_SEE_YOU_BACK"], texts["LOGIN.TITLE"]);
    } catch (err: any) {
      this._message.emitChange("LOADING", "END");
      this.toLogin(err?.message || 'SSO_CODE_INVALID');
    }
  }

  private toLogin(error: string) {
    this.router.navigate(['/login'], { queryParams: { error }, replaceUrl: true });
  }
}
